import React from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from '../../../components/ui/Modal';
import { Input } from '../../../components/ui/Input';
import { Textarea } from '../../../components/ui/Textarea';
import { Button } from '../../../components/ui/Button';
import { inviteSchoolAdmin } from '../../../modules/platform/api/devteam';
import { showErrorToast, showSuccessToast } from '../../../utils/errorHandler';

interface Props {
  isOpen: boolean;
  schoolId: string | null;
  schoolName?: string;
  defaultEmail?: string;
  onClose: () => void;
  onSuccess?: () => void;
}

interface FormData {
  email: string;
  invitee_name?: string;
  notes?: string;
}

export const InviteAdminModal: React.FC<Props> = ({ isOpen, schoolId, schoolName, defaultEmail, onClose, onSuccess }) => {
  const { register, handleSubmit, formState: { errors, isSubmitting }, reset } = useForm<FormData>({
    defaultValues: { invitee_name: 'School Admin' },
  });

  const submit = async (values: FormData) => {
    if (!schoolId) return;
    try {
      await inviteSchoolAdmin(schoolId, values);
      showSuccessToast('Invite sent');
      onSuccess && onSuccess();
      onClose();
    } catch (err: any) {
      const msg = err?.response?.data?.error?.message || err?.message || 'Invite failed';
      showErrorToast(msg);
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      reset({
        invitee_name: 'School Admin',
        email: defaultEmail || '',
        notes: '',
      });
    } else {
      reset({
        invitee_name: 'School Admin',
        email: '',
        notes: '',
      });
    }
  }, [isOpen, defaultEmail, reset]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Invite Admin${schoolName ? ` — ${schoolName}` : ''}`} size="sm">
      <form id="invite-admin-form" onSubmit={handleSubmit(submit)} className="space-y-4">
        <Input label="Email" type="email" {...register('email', { required: 'Email is required' })} error={errors.email?.message} />
        <Input label="Invitee Name" {...register('invitee_name')} />
        <Textarea label="Notes" {...register('notes')} rows={3} />
        <div className="flex justify-end gap-3 pt-2">
          <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
          <Button type="submit" form="invite-admin-form" isLoading={isSubmitting}>Send Invite</Button>
        </div>
      </form>
    </Modal>
  );
};

export default InviteAdminModal;

